import { Button } from '@/components/ui/button'
import { HomeIcon, MegaphoneIcon, NewspaperIcon, UsersIcon } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { LinkButton } from '../ui'
import FeatureCard from './FeatureCard'
import { HomeContentBlock, HomeParagraph, HomeSection, HomeTitle } from './base'

const steps = [
  {
    step: '1',
    icon: <HomeIcon className='w-8 h-8 stroke-1' />,
    title: 'Set Up Workspace',
  },
  {
    step: '2',
    icon: <UsersIcon className='w-8 h-8 stroke-1' />,
    title: 'Invite Team Members',
  },
  {
    step: '3',
    icon: <NewspaperIcon className='w-8 h-8 stroke-1' />,
    title: 'Publish Content',
  },
  {
    step: '4',
    icon: <MegaphoneIcon className='w-8 h-8 stroke-1' />,
    title: 'Monitor Insights',
  },
]

const HowItWorks = () => {
  return (
    <HomeSection padding='lg' className='relative w-full max-w-none'>
      <div
        className='absolute inset-0 w-full opacity-20'
        style={{
          backgroundImage: 'url(/images/home/howitworks_bg.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div className='relative z-10 grid grid-cols-1 md:grid-cols-2 gap-24 px:0 lg:px-6  max-w-7xl mx-auto'>
        <HomeContentBlock>
          <div>
            <HomeTitle className='mb-4'>How It Works</HomeTitle>
            <HomeParagraph>Get started in minutes — simple steps to manage your media operations.</HomeParagraph>
          </div>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            {steps.map((step) => (
              <FeatureCard key={step.title} icon={step.icon} title={step.title} />
            ))}
          </div>

          <div className='w-fit'>
            <LinkButton href='/signup' className='bg-neutral-800 text-white hover:bg-neutral-700'>
              Get Started
            </LinkButton>
          </div>
        </HomeContentBlock>

        <div className='flex items-center justify-center'>
          <Image src='/images/home/howitworks_img.webp' alt='How It Works' width={1000} height={1000} />
        </div>
      </div>
    </HomeSection>
  )
}

export default HowItWorks
